// extracted by mini-css-extract-plugin
export var icon = "_4w-1";
export var subtext = "_4w-0";